/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';

/**
 * 
 * @export
 * @interface ReplaceTeamOutputBody
 */
export interface ReplaceTeamOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ReplaceTeamOutputBody
     */
    readonly $schema?: string;
    /**
     * Team
     * @type {Team}
     * @memberof ReplaceTeamOutputBody
     */
    team: Team;
}

/**
 * Check if a given object implements the ReplaceTeamOutputBody interface.
 */
export function instanceOfReplaceTeamOutputBody(value: object): value is ReplaceTeamOutputBody {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function ReplaceTeamOutputBodyFromJSON(json: any): ReplaceTeamOutputBody {
    return ReplaceTeamOutputBodyFromJSONTyped(json, false);
}

export function ReplaceTeamOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceTeamOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'team': TeamFromJSON(json['team']),
    };
}

export function ReplaceTeamOutputBodyToJSON(json: any): ReplaceTeamOutputBody {
    return ReplaceTeamOutputBodyToJSONTyped(json, false);
}

export function ReplaceTeamOutputBodyToJSONTyped(value?: Omit<ReplaceTeamOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TeamToJSON(value['team']),
    };
}

